import { render, staticRenderFns } from "./NewsTable.vue?vue&type=template&id=d934915e&scoped=true&"
import script from "./NewsTable.vue?vue&type=script&lang=js&"
export * from "./NewsTable.vue?vue&type=script&lang=js&"
import style0 from "./NewsTable.vue?vue&type=style&index=0&id=d934915e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d934915e",
  null
  
)

export default component.exports